/* tslint:disable */
/* eslint-disable */
/**
 * Ptw100 API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues, typeFirst } from '../runtime';
import type { EntityOrigin } from './EntityOrigin';
import {
    EntityOriginFromJSON,
    EntityOriginFromJSONTyped,
    EntityOriginToJSON,
} from './EntityOrigin';
import type { EnumerationOptionDto } from './EnumerationOptionDto';
import {
    EnumerationOptionDtoFromJSON,
    EnumerationOptionDtoFromJSONTyped,
    EnumerationOptionDtoToJSON,
} from './EnumerationOptionDto';
import type { EnumerationValueDtoValue } from './EnumerationValueDtoValue';
import {
    EnumerationValueDtoValueFromJSON,
    EnumerationValueDtoValueFromJSONTyped,
    EnumerationValueDtoValueToJSON,
} from './EnumerationValueDtoValue';

/**
 * 
 * @export
 * @interface EnumerationValueDto
 */
export interface EnumerationValueDto {
    /**
     * 
     * @type {string}
     * @memberof EnumerationValueDto
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof EnumerationValueDto
     */
    dataTypeId?: string;
    /**
     * 
     * @type {string}
     * @memberof EnumerationValueDto
     */
    name?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof EnumerationValueDto
     */
    isRequired?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof EnumerationValueDto
     */
    isReadonly?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof EnumerationValueDto
     */
    isEnabled?: boolean;
    /**
     * 
     * @type {string}
     * @memberof EnumerationValueDto
     */
    iuid?: string | null;
    /**
     * 
     * @type {EntityOrigin}
     * @memberof EnumerationValueDto
     */
    origin?: EntityOrigin;
    /**
     * 
     * @type {EnumerationValueDtoValue}
     * @memberof EnumerationValueDto
     */
    value?: EnumerationValueDtoValue | null;
    /**
     * 
     * @type {boolean}
     * @memberof EnumerationValueDto
     */
    isUsedForEvaluation?: boolean;
    /**
     * 
     * @type {Array<EnumerationOptionDto>}
     * @memberof EnumerationValueDto
     */
    options?: Array<EnumerationOptionDto> | null;
    /**
     * 
     * @type {string}
     * @memberof EnumerationValueDto
     */
    groupName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof EnumerationValueDto
     */
    groupHash?: string | null;
    /**
     * 
     * @type {string}
     * @memberof EnumerationValueDto
     */
    $type?: EnumerationValueDtoTypeEnum;
}


/**
 * @export
 */
export const EnumerationValueDtoTypeEnum = {
    PtwPtw100AppZeroApplicationSharedDataTypeManagementDtoEnumerationDtoEnumerationValueDtoPtwPtw100AppZeroApplicationShared: 'Ptw.Ptw100.AppZero.Application.Shared.DataTypeManagement.Dto.EnumerationDto.EnumerationValueDto, Ptw.Ptw100.AppZero.Application.Shared'
} as const;
export type EnumerationValueDtoTypeEnum = typeof EnumerationValueDtoTypeEnum[keyof typeof EnumerationValueDtoTypeEnum];


/**
 * Check if a given object implements the EnumerationValueDto interface.
 */
export function instanceOfEnumerationValueDto(value?: unknown): value is EnumerationValueDto {
    return !!value && typeof value === 'object' && "$type" in value && value.$type === Object.values(EnumerationValueDtoTypeEnum)[0];
}

export function EnumerationValueDtoFromJSON(json: any): EnumerationValueDto {
    return EnumerationValueDtoFromJSONTyped(json, false);
}

export function EnumerationValueDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): EnumerationValueDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'dataTypeId': !exists(json, 'dataTypeId') ? undefined : json['dataTypeId'],
        'name': !exists(json, 'name') ? undefined : json['name'],
        'isRequired': !exists(json, 'isRequired') ? undefined : json['isRequired'],
        'isReadonly': !exists(json, 'isReadonly') ? undefined : json['isReadonly'],
        'isEnabled': !exists(json, 'isEnabled') ? undefined : json['isEnabled'],
        'iuid': !exists(json, 'iuid') ? undefined : json['iuid'],
        'origin': !exists(json, 'origin') ? undefined : EntityOriginFromJSON(json['origin']),
        'value': !exists(json, 'value') ? undefined : EnumerationValueDtoValueFromJSON(json['value']),
        'isUsedForEvaluation': !exists(json, 'isUsedForEvaluation') ? undefined : json['isUsedForEvaluation'],
        'options': !exists(json, 'options') ? undefined : (json['options'] === null ? null : (json['options'] as Array<any>).map(EnumerationOptionDtoFromJSON)),
        'groupName': !exists(json, 'groupName') ? undefined : json['groupName'],
        'groupHash': !exists(json, 'groupHash') ? undefined : json['groupHash'],
        '$type': !exists(json, '$type') ? undefined : json['$type'],
    };
}

export function EnumerationValueDtoToJSON(value?: EnumerationValueDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return typeFirst({
        
        'id': value.id,
        'dataTypeId': value.dataTypeId,
        'name': value.name,
        'isRequired': value.isRequired,
        'isReadonly': value.isReadonly,
        'isEnabled': value.isEnabled,
        'iuid': value.iuid,
        'origin': EntityOriginToJSON(value.origin),
        'value': EnumerationValueDtoValueToJSON(value.value),
        'isUsedForEvaluation': value.isUsedForEvaluation,
        'options': value.options === undefined ? undefined : (value.options === null ? null : (value.options as Array<any>).map(EnumerationOptionDtoToJSON)),
        'groupName': value.groupName,
        'groupHash': value.groupHash,
        '$type': value.$type,
    });
}

